import { TransmissionMode } from '@/types/types';

export const normalizeTransmission = (t: unknown): TransmissionMode | null => {
  const v = String(t ?? '').toLowerCase();
  return v === 'manual' || v === 'automatic' ? (v as TransmissionMode) : null;
};

export const hasMultipleTransmissions = (vehicles: any[]): boolean => {
  const set = new Set<TransmissionMode>();

  for (const v of vehicles) {
    for (const t of v.transmissions ?? []) {
      const nt = normalizeTransmission(t);
      if (nt) set.add(nt);
      if (set.size > 1) return true;
    }
  }

  return false;
};
